// TI.js

import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Bar } from 'react-chartjs-2';
import './TI.css';

// TIChart 參數一樣，處理一組最多 10 筆
function TIChart({ data }) {
    const navigate = useNavigate();
    const labels = data.map((d) => d.name);
    const toNumericOrNull = (value) => {
        if (value === null || value === undefined || value === '') return null;
        const parsed = parseFloat(value);
        return Number.isNaN(parsed) ? null : parsed;
    };
    const ds1 = data.map((d) => toNumericOrNull(d.value13));
    const ds2 = data.map((d) => toNumericOrNull(d.value24));

    const chartData = {
        labels,
        datasets: [
            { label: '1-3', data: ds1, backgroundColor: '#4f81bd' },
            { label: '2-4', data: ds2, backgroundColor: '#c0504d' },
        ],
    };

    const yellowThresh = 825;
    const redThresh = 2062;

    const options = {
        responsive: true,
        maintainAspectRatio: false,
        onClick: (evt, activeEls) => {
            if (activeEls.length > 0) {
                const elementName = data[activeEls[0].index].name;
                navigate(`/device/${elementName}`);
            }
        },
        chunkHighlight: {
            enabled: true, // 這一行控制是否啟用
            highlightColor: 'rgba(0, 0, 0, 0.08)', // 這可以自行調整高亮顏色
        },
        plugins: {
            legend: { position: 'bottom' },
            title: { display: true, text: '即時傾斜計監測 — TI' },
            tooltip: {
                callbacks: {
                    label: (context) => {
                        const value = context.raw;
                        if (value === null || value === undefined) {
                            return `${context.dataset.label}: 無資料`;
                        }
                        return `${context.dataset.label}: ${value}`;
                    },
                },
            },
            customCrosshair: {
                enabled: true,
                stepSize: 1,
                unit: '秒',
            },
            annotation: {
                annotations: {
                    // 警戒正
                    yellowHigh: {
                        type: 'line',
                        yMin: yellowThresh,
                        yMax: yellowThresh,
                        borderColor: 'orange',
                        borderWidth: 2,
                        borderDash: [6, 3],
                        label: {
                            display: true,
                            content: '警戒值',
                            position: 'start',
                            backgroundColor: 'orange',
                            color: '#fff',
                            font: { size: 10 },
                        },
                    },
                    // 警戒負
                    yellowLow: {
                        type: 'line',
                        yMin: -yellowThresh,
                        yMax: -yellowThresh,
                        borderColor: 'orange',
                        borderWidth: 2,
                        borderDash: [6, 3],
                        label: {
                            display: true,
                            content: '警戒值',
                            position: 'start',
                            backgroundColor: 'orange',
                            color: '#fff',
                            font: { size: 10 },
                        },
                    },
                    // 行動正
                    redHigh: {
                        type: 'line',
                        yMin: redThresh,
                        yMax: redThresh,
                        borderColor: 'red',
                        borderWidth: 2,
                        borderDash: [6, 3],
                        label: {
                            display: true,
                            content: '行動值',
                            position: 'start',
                            backgroundColor: 'red',
                            color: '#fff',
                            font: { size: 10 },
                        },
                    },
                    // 行動負
                    redLow: {
                        type: 'line',
                        yMin: -redThresh,
                        yMax: -redThresh,
                        borderColor: 'red',
                        borderWidth: 2,
                        borderDash: [6, 3],
                        label: {
                            display: true,
                            content: '行動值',
                            position: 'start',
                            backgroundColor: 'red',
                            color: '#fff',
                            font: { size: 10 },
                        },
                    },
                },
            },
        },
        scales: {
            x: { ticks: { autoSkip: false, maxRotation: 45, minRotation: 45 } },
            y: {
                title: { display: true, text: '傾斜量 (秒)' },
                min: -2500,
                max: 2500,
                ticks: {
                    stepSize: 250,
                    // callback: (val) => {
                    //     return val === 0 || val === 500 || val === -500 ? val : '';
                    // },
                },
            },
        },
        interaction: { mode: 'index', intersect: false },
    };

    return <Bar data={chartData} options={options} />;
}

// 最後在 TI 裡面切 chunk，每 10 筆一組
export default function TI({ tilt }) {
    const chunkSize = 10;
    const chunks = [];
    for (let i = 0; i < tilt.length; i += chunkSize) {
        chunks.push(tilt.slice(i, i + chunkSize));
    }

    return (
        <div className="ti-container">
            {chunks.map((chunk, idx) => (
                <div className="ti-row" key={idx}>
                    <TIChart data={chunk} />
                </div>
            ))}
        </div>
    );
}
